import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "lever"];

  static classes = ["active", "inactive", "activeLever", "inactiveLever"];

  static values = {
    checked: {
      type: Boolean,
      default: false,
    },
  };

  toggle = () => (this.checkedValue = !this.checkedValue);

  checkedValueChanged(state, _) {
    this.element.ariaChecked = this.element.ariaChecked == state;
    if (this.hasInputTarget) this.inputTarget.value = state;

    this.element.classList.toggle(...this.activeClasses, state);
    this.element.classList.toggle(...this.inactiveClasses, !state);

    this.leverTarget.classList.toggle(...this.activeLeverClasses, state);
    this.leverTarget.classList.toggle(...this.inactiveLeverClasses, !state);
  }
}
